<template>
  <div>
    <!-- 🔼 Header -->
    <div class="slide mb-5" style="margin-top: 74px !important;">
      <div class="bg-img">
        <div class="slide-content">
          <div>
            <h2 class="slide-header">{{ 'Inventory' }}</h2>
          </div>
          <div>
            <h5 class="slide-h5">{{ $t('message.home') }}</h5>
            <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider" />
            <h5 class="slide-h5">{{ 'Inventory' }}</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-3 mb-5">
      <b-form-group label="Select Store to show Inventories">
        <v-select v-model="store_id" :options="stores" :reduce="store => store.id" @input="handleStoreChange"
          label="name" class="form-control" style="border: none !important; padding: 0px !important;"
          placeholder="Select store" required />
      </b-form-group>
      <div v-if="this.store_id" class="d-flex justify-content-between align-items-center">
        <h4 class="item-details-header mt-4 mb-4">Inventory List</h4>
        <b-button size="sm" class="btn-success store-action-btn" @click="showModal = true">
          Create Inventory
        </b-button>
      </div>

      <!-- 🔍 Filter input -->
      <!-- <b-form-input
        v-model="filterText"
        placeholder="Search inventory by description..."
        class="mb-3"
      ></b-form-input> -->

      <!-- 🧾 Cards -->
      <div class="">


        <b-row>
          <b-col v-for="(invoice, index) in inventories" :key="invoice.id" cols="12" md="6" lg="4" class="mb-4">
            <div class="invoice-card" @click="goToInventoryDetails(invoice)" style="cursor: pointer;">
              <div class="invoice-header">
                <h5>
                  <b-icon icon="file-earmark-text" variant="primary" class="mr-2" />
                  {{ invoice.description }}
                </h5>

                <b-badge v-if="invoice.type !== '1'" :variant="getInventoryStatusVariant(invoice.status)">
                  {{ getInventoryStatusText(invoice.status) }}
                </b-badge>


              </div>

              <div class="invoice-body">
                <!-- <p>
                                <b-icon icon="person-fill" class="mr-2" />
                                <strong>Supplier:</strong> {{ invoice.supplier_name }}
                            </p> -->
                <p>
                  <b-icon icon="gear-fill" class="mr-2 text-info" />
                  <strong>Type :</strong>
                  {{ invoice.type == '1' ? 'Manual' : 'Automatic' }}
                </p>
                <p>
                  <b-icon icon="calendar-event-fill" class="mr-2 text-success" />
                  <strong>Due Date :</strong>
                  {{ invoice.due_date }}
                </p>
                <p>
                  <b-icon icon="eye-fill" class="mr-2 text-warning" />
                  <strong>Visible Quantity :</strong>
                  {{ invoice.quantity_visable == '1' ? 'Yes' : 'No' }}
                </p>

                <!-- <div class="mb-2 text-primary font-weight-bold"> -->
                <p>
                  <b-icon icon="clock-history" class="mr-2" />
                  <strong>Time left : </strong> {{ calculateTimeLeft(invoice.due_date) }}
                  <!-- </div> -->
                </p>

              </div>
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <b-button size="sm" style="border-radius: 10px;" variant="primary" class="mt-2"
                    @click.stop="openAssignModal(invoice)">
                    <b-icon icon="person-plus-fill" class="mr-1" />
                    Assign Users
                  </b-button>
                </div>

                <div class="invoice-footer">
                  <small class="text-muted">
                    <b-icon icon="hash" class="mr-1" />
                    Inventory ID: {{ invoice.id }}
                  </small>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- 📄 Pagination -->
      <b-pagination v-if="totalProducts > perPage" v-model="currentPage" :total-rows="totalProducts" :per-page="perPage"
        align="center" class="mt-3" />

    </div>

    <!-- 🔽 Modal -->
    <b-modal size="lg" scrollable v-model="showModal" class="modal-header custom-modal" title="Create Inventory">
      <b-form>


        <b-form-group label="Date and Time">
          <b-form-input class="form-control" type="datetime-local" v-model="form.due_date" required></b-form-input>
        </b-form-group>

        <b-form-group label="Description">
          <b-form-textarea class="form-control" v-model="form.description" rows="3" required></b-form-textarea>
        </b-form-group>

        <b-form-group label="Inventory Type">
          <v-select v-model="form.type" :options="[
            { label: 'Automatic', value: 0 },
            { label: 'Manual', value: 1 }
          ]" label="label" class="form-control" :reduce="option => option.value" placeholder="Select Inventory Type" />
        </b-form-group>

        <b-form-group label="Quantity Visible">
          <v-select v-model="form.quantity_visable" :options="[
            { label: 'No', value: 0 },
            { label: 'Yes', value: 1 }
          ]" label="label" class="form-control" :reduce="option => option.value"
            placeholder="Select Quantity Visible" />
        </b-form-group>

      </b-form>
      <!-- Modal Footer -->
      <template #modal-footer>
        <b-button variant="secondary" class="footer-btn" @click="showModal = false">Cancel</b-button>
        <b-button variant="primary" class="modalFooter-add footer-btn" @click="submitInventory()">Save</b-button>
      </template>
    </b-modal>

    <b-modal size="lg" scrollable v-model="assignModalVisible" class="modal-header custom-modal"
      title="Assign Inventory Users">
      <b-form>


        <b-form-group label="Admin Users">
          <v-select v-model="assignForm.admin" :options="filteredAdmins" placeholder="Select admin users"
            :reduce="option => option.value" label="label" multiple />
        </b-form-group>

        <b-form-group label="Technicians">
          <v-select v-model="assignForm.technicals" :options="technicalsList" placeholder="Select technicians"
            :reduce="option => option.value" label="label" multiple />
        </b-form-group>

        <b-form-group label="Company Users">
          <v-select v-model="assignForm.company" :options="companyUsersList" placeholder="Select company users"
            :reduce="option => option.value" label="label" multiple />
        </b-form-group>






      </b-form>



      <template #modal-footer>
        <b-button variant="secondary" class="footer-btn" @click="assignModalVisible = false">Cancel</b-button>
        <b-button variant="primary" class="modalFooter-add footer-btn" @click="submitAssignedUsers()">Save</b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import axiosInstance from '../axios-config';
import { mapGetters } from 'vuex';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      showModal: false,
      inventories: [],
      totalProducts: 0,
      form: {
        due_date: '',
        description: '',
        type: null,
        quantity_visable: null,
      },
      store_id: null,
      filterText: '',
      currentPage: 1,
      perPage: 6,
      now: new Date(), // ⏳ الوقت الحالي المتجدد
      intervalId: null,

      assignModalVisible: false,
      selectedInventoryId: null,
      admins: [],
      technicalsList: [],
      companyUsersList: [],

      assignForm: {
        admin: [],
        technicals: [],
        company: [],
      },
      stores: [],


    };
  },
  computed: {
    ...mapGetters(['getUser']),
    user() {
      return this.getUser;
    },
    isRTL() {
      return this.$i18n.locale === 'ar';
    },
    filteredAdmins() {
      const selectedIds = [
        this.assignForm.technical,
        this.assignForm.company,
      ].filter(Boolean); // لمنع التكرار في الاختيارات الأخرى

      return this.admins.filter(admin => !selectedIds.includes(admin.value));
    },
    // 🔍 Filter
    filteredInventories() {
      if (!this.filterText) return this.inventories;
      return this.inventories.filter(item =>
        item.description?.toLowerCase().includes(this.filterText.toLowerCase())
      );
    },
    // 📄 Pagination
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredInventories.slice(start, end);
    },
  },
  watch: {
    filterText() {
      this.currentPage = 1;
    },
    currentPage() {
      this.fetchInventories(); // تحميل الصفحة الجديدة
    },
  },

  mounted() {
    this.fetchStores();
    // ⏱️ تحديث الوقت كل ثانية
    this.intervalId = setInterval(() => {
      this.now = new Date();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    calculateTimeLeft(dueDate) {
      const due = new Date(dueDate);
      const diff = due - this.now;

      if (diff <= 0) return 'Inventory expired';

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      return `${days}d / ${hours}h / ${minutes}m / ${seconds}s`;
    },

    handleStoreChange() {
      if (this.store_id) {
        this.fetchInventories();
      }
    },


    async fetchInventories() {
      try {
        const formData = new FormData();
        formData.append('store_id', this.store_id);
        formData.append('page_size', this.perPage);
        formData.append('page', this.currentPage);

        const response = await axiosInstance.post('store/select_inventories.php', formData);
        if (response.data.status === 'true') {
          this.inventories = response.data.output;
          this.totalProducts = response.data.pagination?.total_products; // 🆕
        }
      } catch (err) {
        console.error('Error fetching inventories:', err);
        this.$izitoast.error({
          title: "خطأ",
          message: 'Error occurred.',
          position: "bottomLeft",
        });
      }
    },

    async fetchStores() {
      try {
        const formData = new FormData();
        formData.append("company_id", this.user.company_id); // لو موجود في اليوزر

        const res = await axiosInstance.post("store/select_stores.php", formData);

        if (res.data.status === "true") {
          this.stores = res.data.output;
        }
      } catch (err) {
        console.error("Error fetching stores", err);
      }
    },

    async submitInventory() {
      if (!this.store_id) {
        this.$izitoast.warning({
          title: "Warning",
          message: "Please select a store first.",
          position: "bottomLeft",
        });
        return;
      }

      try {
        const formData = new FormData();
        formData.append('due_date', this.formatDate(this.form.due_date));
        formData.append('description', this.form.description);
        formData.append('type', this.form.type);
        formData.append('quantity_visable', this.form.quantity_visable);
        formData.append('store_id', this.store_id); // ✅ store المختار

        const res = await axiosInstance.post('store/insert_inventory.php', formData);

        if (res.data.status === 'true') {
          const inventoryId = res.data.output.id;
          this.$izitoast.success({
            title: "Success",
            message: "Inventory created successfully!",
            position: "bottomLeft",
          });

          this.showModal = false;
          this.fetchInventories(); // ✅ اعادة تحميل الجدول

          // Reset form (اختياري)
          this.form = {
            due_date: '',
            description: '',
            type: null,
            quantity_visable: null
          };
          // ✅ بعد الإنشاء، اعمل Assign للـ Admin مباشرة
          this.autoAssignAdmin(inventoryId);

        } else {
          this.$izitoast.error({
            title: "Error",
            message: res.data.message || 'Error occurred.',
            position: "bottomLeft",
          });
        }
      } catch (error) {
        console.error(error);
        this.$izitoast.error({
          title: "Error",
          message: "Failed to create inventory.",
          position: "bottomLeft",
        });
      }
    },

    async autoAssignAdmin(inventoryId) {
      const payload = [
        {
          user_id: this.user.id, // ID المستخدم الحالي
          type: 1                // Admin
        }
      ];

      try {
        const response = await axiosInstance.post(
          `store/insert_inventory_users.php?inventory_id=${inventoryId}`,
          payload,
          { headers: { 'Content-Type': 'application/json' } }
        );

        if (response.data.status === 'true') {
          this.$izitoast.success({
            title: "تم",
            message: "تم تعيين المدير للجرد بنجاح.",
            position: "bottomLeft",
          });
        } else {
          throw new Error(response.data.message || 'Unknown error');
        }
      } catch (error) {
        console.error('Auto assign error:', error);
        this.$izitoast.error({
          title: "خطأ",
          message: "فشل في تعيين المدير تلقائيًا.",
          position: "bottomLeft",
        });
      }
    },

    formatDate(dateTimeInput) {
      const date = new Date(dateTimeInput);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const hh = String(date.getHours()).padStart(2, '0');
      const mi = String(date.getMinutes()).padStart(2, '0');
      const ss = String(date.getSeconds()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
    },
    async openAssignModal(invoice) {
      this.selectedInventoryId = invoice.id;
      this.assignModalVisible = true;
      await this.fetchAdmins();
      await this.fetchTechnicals();
      await this.fetchCompanyUsers();
    },


    async fetchAdmins() {
      try {
        const formData = new FormData();
        formData.append('company_id', this.user.company_id);
        formData.append('offset', 0);

        const res = await axiosInstance.post('company/select_admins.php', formData);
        if (res.data.status === 'true') {
          this.admins = res.data.output.map(user => ({
            label: user.name,
            value: parseInt(user.id),
          }));
        } else {
          this.admins = [];
        }
      } catch (err) {
        console.error('Failed to fetch admins', err);
      }
    },

    async fetchTechnicals() {
      try {
        const formData = new FormData();
        formData.append('company_id', this.user.company_id); // أو من الـ user أو vuex حسب عندك

        const res = await axiosInstance.post('search_technical.php', formData);

        if (res.data.status === 'true') {
          this.technicalsList = res.data.output.map(tech => ({
            label: tech.name,
            value: parseInt(tech.id),
          }));
        } else {
          this.technicalsList = [];
        }
      } catch (err) {
        console.error('Failed to fetch technicals', err);
      }
    },

    async fetchCompanyUsers() {
      try {
        const formData = new FormData();
        formData.append('company_id', this.user.company_id);
        formData.append('offset', 0);

        const res = await axiosInstance.post('select_employees_company.php', formData);

        if (res.data.status === 'true') {
          this.companyUsersList = res.data.output.map(user => ({
            label: user.name,
            value: parseInt(user.id),
          }));
        } else {
          this.companyUsersList = [];
        }
      } catch (err) {
        console.error('Failed to fetch company users', err);
      }
    },




    async submitAssignedUsers() {
      // 🧩 دمج المجموعات الثلاثة مع النوع المحدد لكل واحدة
      const payload = [
        ...this.assignForm.technicals.map(id => ({ user_id: id, type: 0 })),
        ...this.assignForm.admin.map(id => ({ user_id: id, type: 1 })),
        ...this.assignForm.company.map(id => ({ user_id: id, type: 2 })),
      ];

      if (payload.length === 0) {

        this.$izitoast.warning({
          title: "Warning",
          message: "Please select at least one user",
          position: "bottomLeft",
        });
        return;
      }

      try {
        const response = await axiosInstance.post(
          `store/insert_inventory_users.php?inventory_id=${this.selectedInventoryId}`,
          payload,
          { headers: { 'Content-Type': 'application/json' } }
        );

        if (response.data.status === 'true') {

          this.$izitoast.success({
            title: "Success",
            message: "Users assigned successfully",
            position: "bottomLeft",
          });

          this.assignModalVisible = false;
        } else {
          throw new Error(response.data.message || 'Unknown error');
        }
      } catch (error) {
        console.error('Submit error:', error);

        this.$izitoast.error({
          title: "Error",
          message: "Failed to assign users",
          position: "bottomLeft",
        });
      }
    },
    goToInventoryDetails(inventory) {
      this.$router.push({
        name: 'inventoryDetails',
        params: { inventory_id: inventory.id },  // لو لسه عاوز تحطه في الرابط
        state: { inventoryData: inventory }      // 👈 هنا بتحط الـ item كله
      });
    },

    getInventoryStatusText(status) {
      switch (status) {
        case '0':
          return 'Pending';
        case '1':
          return 'Cancelled';
        case '2':
          return 'Completed';
        case '3':
          return 'Pending Approval';
        default:
          return 'Unknown';
      }
    },
    getInventoryStatusVariant(status) {
      switch (status) {
        case '0':
          return 'warning';   // Pending
        case '1':
          return 'danger';    // Cancelled
        case '2':
          return 'success';   // Completed
        case '3':
          return 'info';      // Pending Approval
        default:
          return 'secondary';
      }
    }





  },
};
</script>

<style scoped>
.item-history {
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 90px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.item-details-header {
  font-size: 22px;
  font-weight: 600;
  color: #2274BD;
}

#add-employee-modal___BV_modal_content_ .form-control:disabled,
#employee-modal___BV_modal_content_ .form-control:disabled,
#employee-modal___BV_modal_content_ .form-control[readonly],
#add-employee-modal___BV_modal_content_ .form-control[readonly],
#employee-modal___BV_modal_content_ .form-control,
.form-control,
.form-control {
  background: transparent !important;
  border-width: 0px !important;
  border-bottom: 2px solid #D1E4FF !important;
  color: #7F98BB !important;
  font-family: 'Somar-Medium' !important;
  font-size: 20px !important;

}

.form-control:disabled,
.form-control[readonly] {
  background-color: transparent;
  opacity: 1;
}

.form-control:focus {
  box-shadow: none !important;
}

.file-input {
  display: none;
}

/* modal */

.modal-dialog .modal-content {
  border-radius: 10px !important;
  overflow: hidden !important;
  /* لضمان عدم ظهور الحواف خارج الحدود */
}

/* تحسين شكل التمرير */
.modal-dialog .modal-body {
  max-height: 60vh;
  /* لتقييد ارتفاع التمرير */
  overflow-y: auto;
  padding: 1rem;
  scrollbar-width: thin !important;
  /* للمتصفحات الحديثة */
  scrollbar-color: #888 #f0f0f0 !important;
  /* لون شريط التمرير */
}

/* تحسين شكل التمرير للـ webkit (Chrome, Edge, Safari) */
.modal-dialog .modal-body::-webkit-scrollbar {
  width: 8px !important;
  /* عرض شريط التمرير */
}

.modal-dialog .modal-body::-webkit-scrollbar-track {
  background: #f0f0f0 !important;
  /* لون الخلفية */
}

.modal-dialog .modal-body::-webkit-scrollbar-thumb {
  background-color: #888 !important;
  /* لون التمرير */
  border-radius: 4px !important;
}

/* جعل الأزرار في الـ footer دائرية */
.footer-btn {
  border-radius: 10px;
}

/* تحسين المسافات بين الأزرار */
.modal-footer .footer-btn {
  margin: 0 5px;
}

.invoice-card {
  background: linear-gradient(135deg, #f9fcff, #eaf4ff);
  border: none;
  border-left: 6px solid #0d6efd;
  border-radius: 18px;
  padding: 25px;
  box-shadow: 0 6px 20px rgba(13, 110, 253, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
}

.invoice-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 30px rgba(13, 110, 253, 0.15);
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.invoice-header h5 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #0d6efd;
  display: flex;
  align-items: center;
}

.invoice-body {
  font-size: 1.05rem;
  color: #333;
  margin-bottom: 15px;
}

.invoice-body p {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.invoice-body b-icon {
  font-size: 1.2rem;
  margin-right: 10px;
  color: #0d6efd;
}

.invoice-footer {
  text-align: right;
  font-size: 0.95rem;
  color: #666;
}

.custom-modal {
  border-radius: 10px !important;
  padding: 15px;
  /* background: #f8f9fa; */
}
</style>
